import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {RegistrationServiceLocation} from "../../models/registration-service-location";
import Helpers from "../../utils/helpers";

@Injectable()
export class RegistrationServiceLocationControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public getRegistrationServiceLocations(registrationId: string): Observable<RegistrationServiceLocation[]> {
    return this.http.get(this.baseUrl + "registration/" + registrationId + "/registration_service_location") as Observable<RegistrationServiceLocation[]>;
  }

  public getRegistrationServiceLocationsByService(serviceId: string): Observable<RegistrationServiceLocation[]> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/registration_service_location") as Observable<RegistrationServiceLocation[]>;
  }

  public getRegistrationServiceLocation(registrationServiceLocationId: string): Observable<RegistrationServiceLocation> {
    return this.http.get(this.baseUrl + "registration_service_location/" + registrationServiceLocationId) as Observable<RegistrationServiceLocation> ;
  }

  public createServiceLocation(registrationId: string, registrationServiceLocation: RegistrationServiceLocation) {
    Helpers.trimRecursiveObj(registrationServiceLocation);
    const body = JSON.stringify(registrationServiceLocation);
    return this.http.post(this.baseUrl + "registration/" + registrationId + "/registration_service_location", body);
  }

  public saveRegistrationServiceLocation(registrationServiceLocation: RegistrationServiceLocation) {
    Helpers.trimRecursiveObj(registrationServiceLocation);
    const body = JSON.stringify(registrationServiceLocation);
    return this.http.put(this.baseUrl + "registration_service_location", body, {responseType: "text"});
  }

  public deleteRegistrationServiceLocation(registrationServiceLocationId: string) {
    return this.http.delete(this.baseUrl + "registration_service_location/" + registrationServiceLocationId, {responseType: "text"});
  }

  public updateSortOrder(registrationServiceLocations: RegistrationServiceLocation[]) {
    const body = JSON.stringify(registrationServiceLocations);
    return this.http.put(this.baseUrl + "sort_registration_locations", body, {responseType: "text"});
  }
}
